// Chinese Advanced Vocabulary - 50 unique items
// Each item supports 5 question types: target↔english, target↔pinyin, definition→target

import { VocabularyItem } from '../../../utils/multipleChoiceLogic';

export const chineseAdvancedItems: VocabularyItem[] = [
  // Abstract Concepts (1-10)
  {
    id: 'zh-adv-001',
    target: '幸福',
    english: 'Happiness',
    romanization: 'xìng fú',
    definition: 'A state of well-being and contentment',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-adv-002',
    target: '成功',
    english: 'Success',
    romanization: 'chéng gōng',
    definition: 'The achievement of a goal or purpose',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-adv-003',
    target: '经验',
    english: 'Experience',
    romanization: 'jīng yàn',
    definition: 'Knowledge gained through involvement',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-adv-004',
    target: '机会',
    english: 'Opportunity',
    romanization: 'jī huì',
    definition: 'A favorable circumstance for action',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-adv-005',
    target: '责任',
    english: 'Responsibility',
    romanization: 'zé rèn',
    definition: 'A duty to deal with something',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-adv-006',
    target: '文化',
    english: 'Culture',
    romanization: 'wén huà',
    definition: 'The customs and beliefs of a group',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-adv-007',
    target: '环境',
    english: 'Environment',
    romanization: 'huán jìng',
    definition: 'The surroundings or conditions one lives in',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-adv-008',
    target: '社会',
    english: 'Society',
    romanization: 'shè huì',
    definition: 'The community of people living together',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-adv-009',
    target: '关系',
    english: 'Relationship',
    romanization: 'guān xì',
    definition: 'The connection between people or things',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-adv-010',
    target: '影响',
    english: 'Influence / Effect',
    romanization: 'yǐng xiǎng',
    definition: 'The power to affect something or someone',
    partOfSpeech: 'noun/verb'
  },

  // Chinese Idioms & Proverbs (11-20)
  {
    id: 'zh-adv-011',
    target: '入乡随俗',
    english: 'When in Rome, do as the Romans do',
    romanization: 'rù xiāng suí sú',
    definition: 'Adapt to local customs when visiting a place',
    partOfSpeech: 'idiom'
  },
  {
    id: 'zh-adv-012',
    target: '一石二鸟',
    english: 'Kill two birds with one stone',
    romanization: 'yī shí èr niǎo',
    definition: 'Achieve two goals with a single action',
    partOfSpeech: 'idiom'
  },
  {
    id: 'zh-adv-013',
    target: '马马虎虎',
    english: 'So-so / Careless',
    romanization: 'mǎ mǎ hū hū',
    definition: 'Just acceptable; neither good nor bad',
    partOfSpeech: 'idiom'
  },
  {
    id: 'zh-adv-014',
    target: '不好意思',
    english: 'Excuse me / Embarrassed',
    romanization: 'bù hǎo yì si',
    definition: 'Expression of embarrassment or apology',
    partOfSpeech: 'expression'
  },
  {
    id: 'zh-adv-015',
    target: '无所谓',
    english: 'It doesn\'t matter',
    romanization: 'wú suǒ wèi',
    definition: 'Expressing indifference to something',
    partOfSpeech: 'expression'
  },
  {
    id: 'zh-adv-016',
    target: '塞翁失马',
    english: 'A blessing in disguise',
    romanization: 'sài wēng shī mǎ',
    definition: 'An apparent misfortune that becomes beneficial',
    partOfSpeech: 'idiom'
  },
  {
    id: 'zh-adv-017',
    target: '自相矛盾',
    english: 'Self-contradictory',
    romanization: 'zì xiāng máo dùn',
    definition: 'Two statements that cannot both be true',
    partOfSpeech: 'idiom'
  },
  {
    id: 'zh-adv-018',
    target: '半途而废',
    english: 'Give up halfway',
    romanization: 'bàn tú ér fèi',
    definition: 'To abandon something before completion',
    partOfSpeech: 'idiom'
  },
  {
    id: 'zh-adv-019',
    target: '画蛇添足',
    english: 'To gild the lily',
    romanization: 'huà shé tiān zú',
    definition: 'To add unnecessary details; overdo something',
    partOfSpeech: 'idiom'
  },
  {
    id: 'zh-adv-020',
    target: '守株待兔',
    english: 'Waiting for a windfall',
    romanization: 'shǒu zhū dài tù',
    definition: 'Expecting success without effort',
    partOfSpeech: 'idiom'
  },

  // Professional & Academic (21-30)
  {
    id: 'zh-adv-021',
    target: '发展',
    english: 'Development',
    romanization: 'fā zhǎn',
    definition: 'The process of growth or advancement',
    partOfSpeech: 'noun/verb'
  },
  {
    id: 'zh-adv-022',
    target: '科技',
    english: 'Technology',
    romanization: 'kē jì',
    definition: 'Scientific knowledge applied practically',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-adv-023',
    target: '经济',
    english: 'Economy',
    romanization: 'jīng jì',
    definition: 'The system of money and trade',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-adv-024',
    target: '研究',
    english: 'Research',
    romanization: 'yán jiū',
    definition: 'Systematic investigation to establish facts',
    partOfSpeech: 'noun/verb'
  },
  {
    id: 'zh-adv-025',
    target: '教育',
    english: 'Education',
    romanization: 'jiào yù',
    definition: 'The process of teaching and learning',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-adv-026',
    target: '政府',
    english: 'Government',
    romanization: 'zhèng fǔ',
    definition: 'The governing body of a nation',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-adv-027',
    target: '法律',
    english: 'Law',
    romanization: 'fǎ lǜ',
    definition: 'The system of rules in a society',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-adv-028',
    target: '历史',
    english: 'History',
    romanization: 'lì shǐ',
    definition: 'The study of past events',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-adv-029',
    target: '艺术',
    english: 'Art',
    romanization: 'yì shù',
    definition: 'Creative expression through various media',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-adv-030',
    target: '哲学',
    english: 'Philosophy',
    romanization: 'zhé xué',
    definition: 'The study of fundamental questions about existence',
    partOfSpeech: 'noun'
  },

  // Emotions & States (31-40)
  {
    id: 'zh-adv-031',
    target: '焦虑',
    english: 'Anxiety',
    romanization: 'jiāo lǜ',
    definition: 'A feeling of worry or unease',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-adv-032',
    target: '满意',
    english: 'Satisfied',
    romanization: 'mǎn yì',
    definition: 'Feeling content with something',
    partOfSpeech: 'adjective'
  },
  {
    id: 'zh-adv-033',
    target: '失望',
    english: 'Disappointed',
    romanization: 'shī wàng',
    definition: 'Feeling let down by unmet expectations',
    partOfSpeech: 'adjective'
  },
  {
    id: 'zh-adv-034',
    target: '兴奋',
    english: 'Excited',
    romanization: 'xīng fèn',
    definition: 'Feeling enthusiastic and eager',
    partOfSpeech: 'adjective'
  },
  {
    id: 'zh-adv-035',
    target: '孤独',
    english: 'Lonely',
    romanization: 'gū dú',
    definition: 'Feeling sad from being alone',
    partOfSpeech: 'adjective'
  },
  {
    id: 'zh-adv-036',
    target: '骄傲',
    english: 'Proud',
    romanization: 'jiāo ào',
    definition: 'Feeling satisfaction from achievements',
    partOfSpeech: 'adjective'
  },
  {
    id: 'zh-adv-037',
    target: '羡慕',
    english: 'Envy / Admire',
    romanization: 'xiàn mù',
    definition: 'Desire to have what someone else has',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-adv-038',
    target: '后悔',
    english: 'Regret',
    romanization: 'hòu huǐ',
    definition: 'Feeling sorry about past actions',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-adv-039',
    target: '感激',
    english: 'Grateful',
    romanization: 'gǎn jī',
    definition: 'Feeling thankful for something',
    partOfSpeech: 'adjective'
  },
  {
    id: 'zh-adv-040',
    target: '尴尬',
    english: 'Awkward / Embarrassed',
    romanization: 'gān gà',
    definition: 'Feeling uncomfortable in a social situation',
    partOfSpeech: 'adjective'
  },

  // Complex Actions (41-50)
  {
    id: 'zh-adv-041',
    target: '解决',
    english: 'To solve',
    romanization: 'jiě jué',
    definition: 'To find an answer to a problem',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-adv-042',
    target: '考虑',
    english: 'To consider',
    romanization: 'kǎo lǜ',
    definition: 'To think carefully about something',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-adv-043',
    target: '决定',
    english: 'To decide',
    romanization: 'jué dìng',
    definition: 'To make a choice or resolution',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-adv-044',
    target: '接受',
    english: 'To accept',
    romanization: 'jiē shòu',
    definition: 'To receive or agree to something',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-adv-045',
    target: '拒绝',
    english: 'To refuse',
    romanization: 'jù jué',
    definition: 'To decline or say no to something',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-adv-046',
    target: '讨论',
    english: 'To discuss',
    romanization: 'tǎo lùn',
    definition: 'To talk about something in detail',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-adv-047',
    target: '提醒',
    english: 'To remind',
    romanization: 'tí xǐng',
    definition: 'To cause someone to remember something',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-adv-048',
    target: '表达',
    english: 'To express',
    romanization: 'biǎo dá',
    definition: 'To convey thoughts or feelings',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-adv-049',
    target: '证明',
    english: 'To prove',
    romanization: 'zhèng míng',
    definition: 'To demonstrate the truth of something',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-adv-050',
    target: '承诺',
    english: 'To promise',
    romanization: 'chéng nuò',
    definition: 'To commit to doing something',
    partOfSpeech: 'verb'
  }
];
